export type RegularityValue = 'One time' | 'Select days'
export interface AlarmSchedule {
  guid: string,
  promptGuids: Array<string>
  promptsType: string,
  date: string,
  time: string,
  name: string,
  number?: number,
  enabled: boolean,
  once: boolean,
  phoneNumber: string,
  monday: boolean,
  tuesday: boolean,
  wednesday: boolean,
  thursday: boolean,
  friday: boolean,
  saturday: boolean,
  sunday: boolean,
  isNew?: boolean
}

export interface PromptAlarm {
  guid: string,
  id: string,
  owner: string,
  categoryName: string,
  name: string,
  description: string,
  textDescription: string,
  path: string,
  type: string,
  isFileReplaceable: boolean,
  isCustomizable: boolean,
  isCustomizedOriginPrompt: boolean,
  isCustomizedTargetPrompt: boolean,
  isCategoryEditable: boolean,
  isNameEditable: boolean,
  isDescriptionEditable: boolean,
  isTextDescriptionEditable: boolean,
  isDeletable: boolean
}

export interface PostAlarmFile {
  file: File,
  promptName: string,
  categoryName: string,
}

export interface PromptCategory {
  guid: string,
  owner: string,
  name: string,
  isSystem: boolean,
}

export enum SelectPromptAlarmItems {
  SUBSCRIBER = 'Subscriber',
  STANDART = 'Standart'
}
